export type CameraGateKind = 'none' | 'primer' | 'blocked';

export interface CameraGateState {
  kind: CameraGateKind;
  onGotIt: () => void;
  onRetry: () => void;
}

const idle: CameraGateState = {
  kind: 'none',
  onGotIt: () => undefined,
  onRetry: () => undefined,
};

let state: CameraGateState = idle;
const listeners = new Set<() => void>();

function emit(): void {
  listeners.forEach((fn) => {
    fn();
  });
}

export function getCameraGate(): CameraGateState {
  return state;
}

export function subscribeCameraGate(listener: () => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function showCameraGate(next: CameraGateState): void {
  state = next;
  emit();
}

export function hideCameraGate(): void {
  state = idle;
  emit();
}
